import { render, staticRenderFns } from "./ChatView.html?vue&type=template&id=4d24b648&scoped=true&"
import script from "./ChatView.vue?vue&type=script&lang=js&"
export * from "./ChatView.vue?vue&type=script&lang=js&"
import style0 from "./ChatView.scss?vue&type=style&index=0&id=4d24b648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d24b648",
  null
  
)

export default component.exports